// extracted by mini-css-extract-plugin
export default {"container":"V0-z","heading":"W0-z","links":"X0-z","copy":"Y0-z","subCopy":"Z0-z","linksLeft":"_0-z","linksCenter":"a1-z","linksRight":"b1-z","link":"c1-z","onlyLink":"d1-z"};